/** 
 Copyright Highway9 Networks Inc. 
 */ 

import { Types } from "~/constants/types";
import evt from "../event";
import { WebSocketMessage } from "~/types/WebsocketMessage";
import { objectTypeToSocketEvent } from "./socketRefreshRegistry";

// Dev-only: logging full objects every WebSocket flush makes DevTools retain them (MCS-3969).
const DEBUG_EVENTS = import.meta.env.DEV;

/**
 * Route a websocket objectType flush to the evt bus.
 * Uniform Entity State refreshes are mapped via socketRefreshRegistry.objectTypes.
 * Emit-only / special cases stay in the switch below.
 */
export function socketRefreshHandler(type: string, patches: WebSocketMessage[]) {
  // Patches are coalesced and merged in the events WebSocket worker before postMessage.

  if (DEBUG_EVENTS) {
    console.log("Processing event", type, patches.map(d => `${d.objectId} : ${d.eventType} (${d.updateEventType})`) , "[Patches]", patches);
  }

  const eventName = objectTypeToSocketEvent.get(type);
  if (eventName) {
    evt.emit(eventName, patches);
    return;
  }

  switch (type) {
    // Emit-only: listeners subscribe via evt.on (e.g. WalkTestView).
    case Types.walkTest:
      evt.emit("refreshWalkTests", patches);
      break;

    default:
      if (type.startsWith("mno")) {
        evt.emit("refreshOperators");
        break;
      }
      console.warn(
        "[socketRefreshHandler] Unhandled websocket objectType",
        type,
        patches.map((patch) => ({
          objectId: patch.objectId,
          eventType: patch.eventType,
          updateEventType: patch.updateEventType,
        })),
      );
      break;
  }
}